export const lightPresetStyle = {
  "focus-action": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(255, 255, 255, 1)",
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 3,
      color: "rgba(53, 65, 68, 1)",
    },
  ],
  "focus-input": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(53, 65, 68, 1)",
      inset: true,
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(53, 65, 68, 1)",
    },
  ],
  "focus-input-error": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(206, 48, 86, 1)",
      inset: true,
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(206, 48, 86, 1)",
    },
  ],
};

export const darkPresetStyle = {
  "focus-action": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(19, 21, 21, 1)",
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 3,
      color: "rgba(198, 205, 207, 1)",
    },
  ],
  "focus-input": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(198, 205, 207, 1)",
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(198, 205, 207, 1)",
      inset: true,
    },
  ],
  "focus-input-error": [
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(250, 117, 138, 1)",
      inset: true,
    },
    {
      x: 0,
      y: 0,
      blur: 0,
      spread: 1,
      color: "rgba(250, 117, 138, 1)",
    },
  ],
};

export type CascadiaStyle = keyof typeof lightPresetStyle;
